module.exports = __webpack_public_path__ + "static/image/together/pc/visual@3x.jpg?59bd60cb";